module.exports = __webpack_public_path__ + "static/media/sessions.90ff5628.webp";